<div class="container">
	<div class="fields">
		<div class="section">
			<div class="section-label">Select a Preferred Start Date</div>
			<div class="scheduling-content start-date">
				<md-icon icon="untitled-ui/time/calendar"></md-icon>
				<input
					type="date"
					[value]="selectedStartDate()"
					md-form-input
					md-date-picker-input
					(update)="updateScheduleStartDate($event)"
					[disabledDateFn]="disableDay()"
				/>
			</div>
		</div>

		<div class="section">
			<div class="section-label">Select the Lesson Frequency</div>
			<div class="scheduling-content">
				<md-icon icon="untitled-ui/media/repeat-02"></md-icon>
				<md-drop-down
					md-form-input
					md-select-input
					[disabled]="!canChangePreferredTimes()"
					(change)="updateLessonFrequency($event)"
					[options]="lessonFrequencyOptions()"
					[value]="selectedFrequency()"
				>
				</md-drop-down>
			</div>
		</div>

		<div class="section">
			<div class="section-label">Select the Learner’s Current Time Zone</div>
			<div class="scheduling-content">
				<md-icon icon="untitled-ui/maps/globe-01"></md-icon>
				<lb-timezone-dropdown [disabled]="!canChangeTimezone()" (change)="updateTimeZone($event)" [value]="selectedTimeZone()"></lb-timezone-dropdown>
			</div>
		</div>
	</div>

	@if (!isAdmin()) {
		<div class="recommendation">
			<md-content-box>
				<div class="header">
					<md-icon icon="untitled-ui/alerts/alert-circle"></md-icon>
					<div class="section-label">Please note</div>
				</div>
				<div class="content">
					Preferred start date must be at least <b>7 calendar days</b> from today. <br /><br />Course lessons <b>expire</b> 4 months following the
					first lesson date for semester enrollments and 8 months after the first lesson for full year enrollments. Tutoring/test prep/conversational
					lessons expire 8 months after the first lesson. <br /><br />Be sure to account for holidays and any relevant
					<b>school transcript deadlines</b> when scheduling.
				</div>
			</md-content-box>
		</div>
	}
</div>
